<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="900px" scrollable>
    <v-card class="rounded-xl" elevation="0" style="border:1px solid #f1f5f9">
      <div class="mdd-head">
        <div class="d-flex align-center" style="gap:10px">
          <div class="mdd-head__icon">
            <v-icon color="#F59E0B" size="20">mdi-sitemap</v-icon>
          </div>
          <div>
            <div class="mdd-head__title">คนที่ฉันแนะนำ</div>
            <div class="mdd-head__sub">เครือข่ายที่เริ่มจากรหัสแนะนำของคุณ</div>
          </div>
        </div>
        <v-btn icon small @click="$emit('input', false)"><v-icon>mdi-close</v-icon></v-btn>
      </div>

      <v-divider />

      <v-card-text class="pa-0" style="max-height:70vh">
        <div class="mdd-tree-wrap" ref="treeWrap"
          @mousedown="onDragStart" @mousemove="onDragMove" @mouseup="onDragEnd" @mouseleave="onDragEnd"
          @click.capture="onWrapClickCapture">
          <div v-if="loading" class="mdd-empty">
            <v-progress-circular indeterminate color="#F59E0B" size="40" />
          </div>
          <div v-else-if="!tree.length" class="mdd-empty">
            <v-icon size="52" color="#E5E7EB">mdi-sitemap</v-icon>
            <p style="color:#9CA3AF;margin-top:10px">ยังไม่มีคนที่คุณแนะนำ</p>
          </div>
          <div v-else class="mdd-forest">
            <org-tree-node
              v-for="root in tree"
              :key="root.refCode"
              :node="root"
              :selected-ref="null"
            />
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import OrgTreeNode from "@/components/OrgTreeNode.vue";
import { getMyDownlineApi } from "@/services/api/commissionServices";

export default {
  name: "MyDownlineDialog",
  components: { OrgTreeNode },
  props: {
    value: { type: Boolean, default: false },
    role:  { type: String, default: "user" },
  },
  data() {
    return {
      tree: [],
      loading: false,
      drag: { active: false, startX: 0, startY: 0, scrollLeft: 0, scrollTop: 0, moved: false },
    };
  },
  watch: {
    value(v) {
      if (v) this.load();
    },
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        const res = await getMyDownlineApi(this.role);
        this.tree = res.tree || [];
      } catch (e) {
        console.error("[MY DOWNLINE]", e);
        this.tree = [];
      } finally {
        this.loading = false;
      }
    },
    onDragStart(e) {
      if (e.button !== 0) return;
      const el = this.$refs.treeWrap;
      this.drag = { active: true, startX: e.pageX, startY: e.pageY, scrollLeft: el.scrollLeft, scrollTop: el.scrollTop, moved: false };
      el.style.cursor = "grabbing";
      e.preventDefault();
    },
    onDragMove(e) {
      if (!this.drag.active) return;
      const dx = e.pageX - this.drag.startX;
      const dy = e.pageY - this.drag.startY;
      if (Math.abs(dx) > 3 || Math.abs(dy) > 3) this.drag.moved = true;
      const el = this.$refs.treeWrap;
      el.scrollLeft = this.drag.scrollLeft - dx;
      el.scrollTop  = this.drag.scrollTop  - dy;
    },
    onDragEnd() {
      if (!this.drag.active) return;
      this.drag.active = false;
      if (this.$refs.treeWrap) this.$refs.treeWrap.style.cursor = "grab";
    },
    onWrapClickCapture(e) {
      if (this.drag.moved) {
        this.drag.moved = false;
        e.stopPropagation();
      }
    },
  },
};
</script>

<style scoped>
.mdd-head {
  display: flex; align-items: flex-start; justify-content: space-between;
  padding: 18px 22px 14px;
}
.mdd-head__icon {
  width: 38px; height: 38px;
  background: #fff7ed;
  border-radius: 10px;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}
.mdd-head__title { font-size: 16px; font-weight: 800; color: #111827; }
.mdd-head__sub   { font-size: 12px; color: #6b7280; margin-top: 2px; }

.mdd-tree-wrap {
  width: 100%;
  min-height: 360px;
  max-height: 70vh;
  overflow: auto;
  padding: 24px;
  cursor: grab;
  background: #F8FAFC;
  scrollbar-width: none;
  -ms-overflow-style: none;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
.mdd-tree-wrap::-webkit-scrollbar { display: none; }
.mdd-forest {
  display: inline-flex;
  gap: 48px;
  flex-wrap: nowrap;
  padding-bottom: 16px;
  margin: 0 auto;
}
.mdd-empty {
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  min-height: 320px;
}
</style>
